// File: frontend/src/config/constants.js

export const APP_NAME = process.env.REACT_APP_SITE_NAME || 'AllegoryOS';
export const APP_ENV = process.env.REACT_APP_APP_ENV || 'dev';
export const ENTERPRISE_ID = process.env.REACT_APP_ENTERPRISE_ID;

// ─────────────────────────────────────────────────────────────────────────────
// Asset CDN
// Base URL for all media assets served via CloudFront.
// ─────────────────────────────────────────────────────────────────────────────
export const ASSETS_BASE_URL = 'https://assets.allegoryinsurance.com';

export const STORAGE_KEYS = {
  USER_ID: 'user_id',
  ANONYMOUS_USER_ID: 'anonymous_user_id',
  SESSION_ID: 'session_id',
  BOOTSTRAP_TIMESTAMP: 'bootstrap_timestamp',
  AUTH_USER: 'auth_user',
  AUTH_TOKENS: 'auth_tokens',
  LANGUAGE: 'language',
  COOKIE_CONSENT: 'cookie_consent',
  CHAT_ID: 'chat_id',
  CHAT_MESSAGES: 'chat_messages'
};

export const MODAL_TYPES = {
  SIGN_IN: 'sign_in',
  SIGN_UP: 'sign_up'
};

export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ACCOUNT_OWNER: 'account_owner',
  ADMIN: 'admin',
  MANAGER: 'manager',
  STANDARD: 'standard',
  PUBLIC: 'public'
};

// Helper to check if user has admin access
export const hasAdminAccess = (userRole) => {
  const adminRoles = [
    USER_ROLES.SUPER_ADMIN,
    USER_ROLES.ACCOUNT_OWNER,
    USER_ROLES.ADMIN,
    USER_ROLES.MANAGER
  ];
  return adminRoles.includes(userRole);
};

export const USER_STATUS = {
  ACTIVE: 'active',
  ANONYMOUS: 'anonymous',
  PENDING: 'pending',
  PENDING_VERIFICATION: 'pending_verification',
  SUSPENDED: 'suspended'
};

export const VERIFICATION_STAGES = {
  PHONE: 'phone',
  EMAIL: 'email',
  COMPLETE: 'complete'
};

export const OTP_LENGTH = 7;
export const OTP_EXPIRY_SECONDS = 120;

// ✅ FIXED: Escaped special characters properly
export const PHONE_REGEX = /^\+?1?\d{10}$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const ZIP_CODE_REGEX = /^\d{5}(-\d{4})?$/;

export const DATE_FORMATS = {
  SHORT: { month: 'numeric', day: 'numeric', year: 'numeric' },
  LONG: { month: 'long', day: 'numeric', year: 'numeric' },
  FULL: { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }
};

export const CURRENCY_FORMAT = {
  style: 'currency',
  currency: 'USD'
};

export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  DASHBOARD: '/dashboard',
  ACCOUNT: '/account',
  PRIVACY: '/privacy-policy',
  TERMS: '/terms-of-service',
  NOT_FOUND: '/404'
};

export const API_ENDPOINTS = {
  FRONTEND_ACTIONS: '/frontend-actions',
  PRIVATE_ACTIONS: '/private-actions'
};

export const WEBSOCKET_RECONNECT = {
  MAX_ATTEMPTS: 5,
  INITIAL_DELAY: 1000,
  MAX_DELAY: 30000
};

export const TOKEN_REFRESH_BUFFER = 300;

// ✅ FIXED: Named export instead of default
const constants = {
  APP_NAME,
  APP_ENV,
  ENTERPRISE_ID,
  STORAGE_KEYS,
  MODAL_TYPES,
  USER_ROLES,
  USER_STATUS,
  VERIFICATION_STAGES,
  OTP_LENGTH,
  OTP_EXPIRY_SECONDS,
  PHONE_REGEX,
  EMAIL_REGEX,
  ZIP_CODE_REGEX,
  DATE_FORMATS,
  CURRENCY_FORMAT,
  ROUTES,
  API_ENDPOINTS,
  WEBSOCKET_RECONNECT,
  TOKEN_REFRESH_BUFFER,
  ASSETS_BASE_URL
};

export default constants;